import React from "react";
import { formatRating } from "./reviewsModel";
import "./reviews.css";

const STAR_PATH = "M12 3l2.6 5.6 6 .6-4.5 4 1.3 6L12 16.8 6.6 19.2l1.3-6-4.5-4 6-.6z";

const Star = ({ filled, size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false"
    className={`rv-star${filled ? " is-on" : ""}`}>
    <path d={STAR_PATH} />
  </svg>
);

/** Read-only stars (rounded to the nearest whole star). */
export const RatingStars = ({ value, size = 16 }) => {
  const filled = Math.round(Number(value) || 0);
  return (
    <span className="rv-stars" role="img" aria-label={`${formatRating(value) || filled} de 5 estrellas`}>
      {[1, 2, 3, 4, 5].map((n) => <Star key={n} filled={n <= filled} size={size} />)}
    </span>
  );
};

/** Compact "★ 4,8 (32)" for the listing cards. Renders nothing without reviews. */
export const RatingBadge = ({ avg, count }) => {
  if (!(Number(count) > 0) || !(Number(avg) > 0)) return null;
  return (
    <span className="rv-badge" data-testid="rating-badge"
      aria-label={`Valoración ${formatRating(avg)} de 5, ${count} ${Number(count) === 1 ? "reseña" : "reseñas"}`}>
      <Star filled size={13} />
      <b>{formatRating(avg)}</b>
      <span className="rv-badge-count">({count})</span>
    </span>
  );
};

/** Radio group of 1-5 stars (arrows move the selection, Space/Enter select). */
export const RatingInput = ({ value, onChange, disabled = false, label = "Calificación" }) => {
  const select = (n) => { if (!disabled) onChange(n); };
  const onKeyDown = (event) => {
    const current = Number(value) || 0;
    if (event.key === "ArrowRight" || event.key === "ArrowUp") { event.preventDefault(); select(Math.min(5, current + 1)); }
    if (event.key === "ArrowLeft" || event.key === "ArrowDown") { event.preventDefault(); select(Math.max(1, current - 1)); }
  };
  return (
    <div className="rv-input" role="radiogroup" aria-label={label} onKeyDown={onKeyDown}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          role="radio"
          aria-checked={Number(value) === n}
          aria-label={`${n} ${n === 1 ? "estrella" : "estrellas"}`}
          tabIndex={Number(value) === n || (!value && n === 1) ? 0 : -1}
          disabled={disabled}
          className="rv-input-btn"
          onClick={() => select(n)}
        >
          <Star filled={n <= (Number(value) || 0)} size={30} />
        </button>
      ))}
    </div>
  );
};

export default RatingStars;
